import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';

const isDashboard = (pathname) => pathname === '/dashboard';

export const Layout = ({ children }) => {
    const location = useLocation();
    // Sidebar closed by default; open only on the dashboard.
    const [isCollapsed, setIsCollapsed] = useState(!isDashboard(location.pathname));

    useEffect(() => {
        setIsCollapsed(!isDashboard(location.pathname));
    }, [location.pathname]);

    const toggleSidebar = () => {
        setIsCollapsed(!isCollapsed);
    };

    // Determine if we should add padding based on the current route
    const isReportPage = location.pathname.startsWith('/reports/') && location.pathname !== '/reports';
    const isReportChatPage = /\/reports\/[^/]+\/chat\/?$/.test(location.pathname);
    const isChartLibraryPage = location.pathname.startsWith('/chart-library');
    const isChartsPage = location.pathname === '/charts';
    const shouldAddPadding = !isReportPage && !isChartLibraryPage && !isChartsPage;

    return (
        <div className="h-screen flex flex-col bg-gray-50 overflow-hidden">
            <Header />
            <div className="flex flex-1 overflow-hidden relative">
                {!isReportChatPage && (
                    <Sidebar isCollapsed={isCollapsed} onToggle={toggleSidebar} />
                )}
                <main
                    className={`flex-1 min-w-0 transition-all duration-300 ${
                        isReportChatPage
                            ? 'flex flex-col overflow-hidden'
                            : 'overflow-auto'
                    } ${shouldAddPadding ? 'page-main' : ''} ${
                        isReportChatPage ? '' : isCollapsed ? 'ml-16' : 'ml-64'
                    }`}
                >
                    {children}
                </main>
            </div>
        </div>
    );
};
